import { useVideoStore } from "@/store/video";
import { usePlayerStore } from "@/store/player";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default async ({ to, pinia }: MiddlewareInterface) => {
  const toHash = to.hash.substring(1) || "";
  const toParts = toHash.split("-");

  const playerStore = usePlayerStore(pinia);

  if (toParts[0] !== "play") {
    if (!playerStore.isPipModeEnabled) {
      await playerStore.setTheaterMode({ videoId: null });
    }

    return;
  }

  if (useVideoStore(pinia).getActiveVideo !== null) {
    return;
  }

  await playerStore.setTheaterMode({ videoId: parseInt(toParts[1]) });
};
